<template>
	<BaseStep
		title="Welche Herausforderungen erlebt Ihr Kind?"
		description="Bitte wählen Sie alle zutreffenden Punkte aus."
	>
		<div class="space-y-3">
			<SelectableCheckboxCard
				v-for="challenge in challenges"
				:id="challenge.id"
				:key="challenge.id"
				:title="challenge.title"
				:description="challenge.description"
				:is-selected="modelValue.includes(challenge.id)"
				:data-test-id="`challenge-${challenge.id}`"
				@toggle="(id: string) => toggleChallenge(id)"
			/>
		</div>
	</BaseStep>
</template>

<script setup lang="ts">
import BaseStep from './BaseStep.vue';
import SelectableCheckboxCard from '@/components/common/SelectableCheckboxCard.vue';

export interface Challenge {
	id: string;
	title: string;
	description: string;
}

interface Props {
	modelValue: string[];
	challenges: Challenge[];
}

const props = defineProps<Props>();
const emit = defineEmits<{
	'update:modelValue': [value: string[]];
}>();

// Methods
const toggleChallenge = (challengeId: string) => {
	const newChallenges = [...props.modelValue];

	// If 'none' is selected, clear all other selections
	if (challengeId === 'none') {
		emit('update:modelValue', ['none']);
		return;
	}

	// If selecting a regular challenge and 'none' was previously selected, remove 'none'
	if (props.modelValue.includes('none')) {
		const index = newChallenges.indexOf('none');
		newChallenges.splice(index, 1);
	}

	// Toggle the selected challenge
	const index = newChallenges.indexOf(challengeId);
	if (index === -1) {
		newChallenges.push(challengeId);
	} else {
		newChallenges.splice(index, 1);
	}

	emit('update:modelValue', newChallenges);
};
</script>
